import React from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";
import Homepage from '../HomePage'
import Homepage2 from '../HomePage2'
import Homepage3 from '../HomePage3'
import RoomPage from '../RoomPage'
import RoomSinglePage from '../RoomSinglePage'
import DestinationPage from '../DestinationPage'
import AboutPage from '../AboutPage'
import ShopPage from '../ShopPage'
import ShopSinglePage from '../ShopSinglePage'
import ServicePage from '../ServicePage'
import ServiceSinglePage from '../ServiceSinglePage'
import FaqPage from '../FaqPage'
import BlogPage from '../BlogPage'
import BlogPageLeft from '../BlogPageLeft'
import BlogPageFullwidth from '../BlogPageFullwidth'
import BlogDetails from '../BlogDetails'
import BlogDetailsLeftSiide from '../BlogDetailsLeftSiide'
import BlogDetailsFull from '../BlogDetailsFull'
import ErrorPage from '../ErrorPage'
import ContactPage from '../ContactPage'
import ProfilePage from '../ProfilePage'
import LoginPage from '../LoginPage'
import SignUpPage from '../SignUpPage'
import ForgotPassword from '../ForgotPassword'
import ChangePassword from '../ChangePassword'

import Dashboard from '../../admin-component/dashboard'
import AdminProfilePage from '../../admin-component/admin-profile-update'
import UsersListPage from '../../admin-component/users-list';
import HotelsListPage from '../../admin-component/hotels-list';
import UserProfileUpdatePage from '../../admin-component/user-profile-update';

import AuthWrapper from '../../services/AuthWrapper';
import HotelUpdatePage from '../../admin-component/hotel-update';
import BookingHistoryList from '../../components/BookingHistoryList';
import BookingHistoryPage from '../BookingHistory';
import WalletHistoryPage from '../WalletHistory';
import WalletHistoryList from '../../components/WalletHistoryList';
import Transactions from '../../admin-component/transactions';
import InformationUpdatePage from '../../admin-component/information-update';
import BankDetailPage from '../BankDetail';
import RulePage from '../RulePage';
import HotelSequencePage from '../../admin-component/hotel-sequence';
import EventsListPage from '../../admin-component/Events/List';
import EventUpdatePage from '../../admin-component/event-update';
import Events from '../EventsPage';

const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route exact path='/' element={<Homepage />} />
          <Route path='home' element={<Homepage />} />
          <Route path='home2' element={<Homepage2 />} />
          <Route path='home3' element={<Homepage3 />} />
          <Route path='hotels' element={<RoomPage />} />
          <Route path='room-single/:id' element={<RoomSinglePage />} />
          <Route path='destination' element={<DestinationPage />} />
          <Route path='about' element={<AboutPage />} />
          <Route path='shop' element={<ShopPage />} />
          <Route path='shop-single' element={<ShopSinglePage />} />
          <Route path='service' element={<ServicePage />} />
          <Route path='service-single' element={<ServiceSinglePage />} />
          <Route path='faq' element={<FaqPage />} />
          <Route path='404' element={<ErrorPage />} />
          <Route path='contact' element={<ContactPage />} />
          <Route path='blog' element={<BlogPage />} />
          <Route path='blog-left' element={<BlogPageLeft />} />
          <Route path='blog-fullwidth' element={<BlogPageFullwidth />} />
          <Route path='blog-details' element={<BlogDetails />} />
          <Route path='blog-details-left' element={<BlogDetailsLeftSiide />} />
          <Route path='blog-details-fullwidth' element={<BlogDetailsFull />} />
          <Route path='login' element={<LoginPage />} />
          <Route path='signup' element={<SignUpPage />} />
          <Route path='forgot-password' element={<ForgotPassword />} />
          <Route path='profile' element={<AuthWrapper><ProfilePage /></AuthWrapper>} />
          <Route path=':id/reset/:token' element={<ChangePassword />} />

          {/* User Routes */}
          <Route path='bookings/history' element={<AuthWrapper><BookingHistoryPage /></AuthWrapper>} />
          <Route path='wallet/transactions' element={<AuthWrapper><WalletHistoryPage /></AuthWrapper>} />
          <Route path='bank/details' element={<AuthWrapper><BankDetailPage /></AuthWrapper>} />
          <Route path='rules' element={<RulePage />} />
          <Route path='events-offers' element={<Events />} />

          {/* Admin Routes */}
          <Route path='admin/dashboard' element={<AuthWrapper><Dashboard /></AuthWrapper>} />
          <Route path='admin/booking/history' element={<AuthWrapper><BookingHistoryList /></AuthWrapper>} />
          <Route path='admin/wallet/transactions/:userId' element={<AuthWrapper><WalletHistoryList /></AuthWrapper>} />
          <Route path='admin/users/transactions' element={<AuthWrapper><Transactions /></AuthWrapper>} />
          <Route path='admin/profile' element={<AuthWrapper><AdminProfilePage /></AuthWrapper>} />
          <Route path='admin/users' element={<AuthWrapper><UsersListPage /></AuthWrapper>} />
          <Route path='admin/hotels' element={<AuthWrapper><HotelsListPage /></AuthWrapper>} />
          <Route path='admin/hotel-sequence/manage' element={<AuthWrapper><HotelSequencePage /></AuthWrapper>} />
          <Route path='admin/user/update/:id' element={<AuthWrapper><UserProfileUpdatePage /></AuthWrapper>} />
          <Route path='admin/hotel/update/:id' element={<AuthWrapper><HotelUpdatePage /></AuthWrapper>} />
          <Route path='admin/information' element={<AuthWrapper><InformationUpdatePage /></AuthWrapper>} />
          <Route path='admin/events' element={<AuthWrapper><EventsListPage /></AuthWrapper>} />
          <Route path='admin/event/update/:id' element={<AuthWrapper><EventUpdatePage /></AuthWrapper>} />
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
